import { render, staticRenderFns } from "./topFavorite.vue?vue&type=template&id=1c976d3c&"
import script from "./topFavorite.vue?vue&type=script&lang=js&"
export * from "./topFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports